export default __webpack_public_path__ + "static/media/border-top3x.baf94a4a.png";